import React, { useState, useEffect } from 'react';
import api from '../services/api';

const InfraDetailsModal = ({ isOpen, infra, onClose, fetchInfraData, onActionComplete }) => {
  const [actionMessage, setActionMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [userRole, setUserRole] = useState('');
  const [isEditMode, setIsEditMode] = useState(false);
  const [editedAmount, setEditedAmount] = useState('');
  const [balanceData, setBalanceData] = useState(null);
  const [isCheckingBalance, setIsCheckingBalance] = useState(false);
  const [balanceError, setBalanceError] = useState('');
  const [uploadedWorkPhoto, setUploadedWorkPhoto] = useState('');
const [isUploadingPhoto, setIsUploadingPhoto] = useState(false);
const [rejectionReason, setRejectionReason] = useState('');
const [showRejectionReason, setShowRejectionReason] = useState(false);
const [treasuryUploading, setTreasuryUploading] = useState(false);
const [editedAmountSpent, setEditedAmountSpent] = useState('');
  // New state for progress tracking
  const [isProgressEditMode, setIsProgressEditMode] = useState(false);
const [progressData, setProgressData] = useState({
  status: '',
  remarks: '',
  // Tendered fields
  isFixed: false,
  fixedDate: '',
  tenderedRemarks: '',
  // Work order fields
  workOrderIssued: false,
  workOrderDate: '',
  workOrderRemarks: '',
  // Work in progress fields
  workProgressPercentage: 25,
  workPhoto: null,
  // Expenditure fields
  expenditureIncurred: false,
  expenditureAmount: '',
  chequeNumber: '',
  expenditureDate: '', // ADD THIS
  expenditureRemarks: '',
  // Physically completed fields
  physicallyCompletedRemarks: '',
  // Completed and bill paid fields
  billDate: '' // ADD THIS
});
const [originalProgressData, setOriginalProgressData] = useState({});
  const [isProgressLoading, setIsProgressLoading] = useState(false);

  useEffect(() => {
    // Get user role from localStorage
    const role = localStorage.getItem('userRole');
    setUserRole(role);
  }, []);

useEffect(() => {
  if (infra) {
    setEditedAmount(infra.amount || '');

    const stageData = Array.isArray(infra.StageData) ? infra.StageData : [];
    let latestStageExpenditure = '';

    for (let index = stageData.length - 1; index >= 0; index--) {
      const stage = stageData[index];
      const stageValue =
        stage?.expenditureAmount ||
        stage?.expenditureIncurredSoFar ||
        '';

      if (stageValue !== undefined && stageValue !== null && stageValue !== '') {
        latestStageExpenditure = stageValue;
        break;
      }
    }

    setEditedAmountSpent(
      infra.amount_spent ??
      infra.expenditure_incurred ??
      infra.expenditureIncurred ??
      infra.expenditureAmount ??
      infra.expenditureIncurredSoFar ??
      latestStageExpenditure ??
      ''
    );

    // Load progress data if exists - initialize empty for new entry
    setProgressData({
      status: '',
      stageOfWorkDuringLastReview: '',
      stageOfWorkAsOnDate: '',
      expenditureIncurredSoFar: '',
      workPhoto: null,
      chequeNumber: '',
      chequePhoto: null,
      remarks: ''
    });
setOriginalProgressData({
  status: '',
  remarks: '',
  isFixed: false,
  fixedDate: '',
  tenderedRemarks: '',
  workOrderIssued: false,
  workOrderDate: '',
  workOrderRemarks: '',
  workProgressPercentage: 25,
  workPhoto: null,
  expenditureIncurred: false,
  expenditureAmount: '',
  expenditureRemarks: '',
  physicallyCompleted: false,
  billPaid: false,
  billDate: '',
  physicallyCompletedRemarks: ''
});
  }
}, [infra]);
  if (!isOpen || !infra) return null;
const handleFileUpload = async (field, file) => {
  if (!file) return;
  
  setIsUploadingPhoto(true);
  try {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await fetch(`${api.BASE_URL}/admin/upload`, {
      method: 'POST',
      headers: {
        'Authorization': localStorage.getItem('authToken')
      },
      body: formData
    });
    
    if (!response.ok) {
      throw new Error('Failed to upload file');
    }
    
    const data = await response.json();
    if (data && !data.error) {
      setUploadedWorkPhoto(data.file);
      setProgressData(prev => ({
        ...prev,
        [field]: file
      }));
      setActionMessage('File uploaded successfully!');
      setTimeout(() => setActionMessage(''), 3000);
    } else {
      throw new Error(data.message || 'Upload failed');
    }
  } catch (error) {
    console.error('Error uploading file:', error);
    setActionMessage(`Failed to upload file: ${error.message}`);
    setTimeout(() => setActionMessage(''), 5000);
  } finally {
    setIsUploadingPhoto(false);
  }
};

const handleSaveAmountSpent = async () => {
  try {
    setIsLoading(true);
    setActionMessage('Saving Expenditure Incurred...');

    const response = await fetch(`${api.BASE_URL}/project/infra/${infra.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem('authToken')
      },
      body: JSON.stringify({
        amount_spent: toAmount(editedAmountSpent)
      })
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(data.message || 'Failed to save Expenditure Incurred');
    }

    infra.amount_spent = toAmount(editedAmountSpent);
    setEditedAmountSpent(String(toAmount(editedAmountSpent)));

    if (typeof fetchInfraData === 'function') {
      fetchInfraData();
    }

    setActionMessage('Expenditure Incurred saved successfully');
    setTimeout(() => setActionMessage(''), 3000);
  } catch (error) {
    console.error('Save Expenditure error:', error);
    setActionMessage(`Error: ${error.message || 'Failed to save Expenditure Incurred'}`);
    setTimeout(() => setActionMessage(''), 5000);
  } finally {
    setIsLoading(false);
  }
};

const handleTreasuryBillUpload = async (event) => {
  const file = event.target.files[0];
  if (!file) return;

  if (file.type !== 'application/pdf') {
    setActionMessage('Error: Please select a PDF file');
    setTimeout(() => setActionMessage(''), 5000);
    event.target.value = '';
    return;
  }

  if (file.size > 10 * 1024 * 1024) {
    setActionMessage('Error: PDF file size must be less than 10MB');
    setTimeout(() => setActionMessage(''), 5000);
    event.target.value = '';
    return;
  }

  try {
    setTreasuryUploading(true);
    setActionMessage('Uploading Treasury Bill document...');

    const formData = new FormData();
    formData.append('file', file);
    formData.append('infra_id', infra.id);
    formData.append('type', 'treasury_bill');

    const uploadResponse = await fetch(`${api.BASE_URL}/admin/upload`, {
      method: 'POST',
      headers: {
        'Authorization': localStorage.getItem('authToken')
      },
      body: formData
    });

    const uploadData = await uploadResponse.json();

    if (!uploadResponse.ok || uploadData.error !== false || !uploadData.file) {
      throw new Error(uploadData.message || 'Failed to upload Treasury Bill document');
    }

    const treasuryFilePath = uploadData.file;

    const updateResponse = await fetch(`${api.BASE_URL}/project/infra/${infra.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem('authToken')
      },
      body: JSON.stringify({
        treasury_bill_doc: [treasuryFilePath]
      })
    });

    const updateData = await updateResponse.json();

    if (!updateResponse.ok || updateData.error) {
      throw new Error(updateData.message || 'Failed to save Treasury Bill document');
    }

    infra.treasury_bill_doc = [treasuryFilePath];

    setActionMessage('Treasury Bill document uploaded successfully');

    if (typeof fetchInfraData === 'function') {
      fetchInfraData();
    }

    event.target.value = '';
    setTimeout(() => setActionMessage(''), 3000);
  } catch (error) {
    console.error('Treasury Bill upload error:', error);
    setActionMessage(`Error: ${error.message || 'Treasury Bill upload failed'}`);
    setTimeout(() => setActionMessage(''), 5000);
  } finally {
    setTreasuryUploading(false);
  }
};

  // Generate infrastructure code in the required format - simplified to use only necessary fields
  const generateInfraCode = (infra) => {
    return `${infra.institute || ''}/WOR/${infra.scheme || ''}/${infra.center || ''}/${infra.year || ''}/${infra.month || ''}/${infra.stitle || ''}/${infra.sno || ''}`;
  };

  // Function to safely render properties that might be objects
  const safeRender = (value) => {
    if (value === null || value === undefined) return 'N/A';
    if (typeof value === 'object') return JSON.stringify(value);
    return value;
  };

  // Amount helper
  const toAmount = (value) => {
    if (value === null || value === undefined || value === '') {
      return 0;
    }

    const cleanedValue = String(value).replace(/,/g, '').trim();
    const numericValue = parseFloat(cleanedValue);

    return Number.isNaN(numericValue) ? 0 : numericValue;
  };

  // Format currency for display
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(toAmount(amount));
  };

  const getUploadUrl = (filePath) => {
  if (!filePath) return '';

  const cleanPath = String(filePath).trim();

  if (
    cleanPath.startsWith('http://') ||
    cleanPath.startsWith('https://')
  ) {
    return cleanPath;
  }

  const normalizedPath = cleanPath.replace(/^\/+/, '');

  if (normalizedPath.startsWith('uploads/')) {
    return `https://crd-training.in/${normalizedPath}`;
  }

  return `https://crd-training.in/uploads/${normalizedPath}`;
};

const getTreasuryDocumentPath = () => {
  const documentValue =
    infra?.treasury_bill_doc ||
    infra?.treasuryBillDoc ||
    infra?.ppa_doc ||
    '';

  if (Array.isArray(documentValue)) {
    return documentValue[0] || '';
  }

  return documentValue || '';
};

const getInfraExpenditureIncurred = () => {
  return toAmount(editedAmountSpent);
};

const getBalanceAmount = () => {
  const amountAllocated = toAmount(infra?.amount);
  const expenditureIncurred = getInfraExpenditureIncurred();

  return amountAllocated - expenditureIncurred;
};



  // Function to check balance before approval
  const checkBalance = async (centerCode, scheme, amount) => {
    try {
      setIsCheckingBalance(true);
      setBalanceError('');
      
      // Construct the API URL with center code and scheme
      const balanceEndpoint = `${centerCode}-${scheme}`;
      
      const response = await fetch(`${api.BASE_URL}/ledger/balance/${balanceEndpoint}`, {
        method: 'GET',
        headers: {
          'Authorization': localStorage.getItem('authToken'),
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        const balanceData = await response.json();
        setBalanceData(balanceData);
        
        // Get balance amount from API response
        const availableBalance = balanceData.data && balanceData.data[0] ? parseFloat(balanceData.data[0].balance) : 0;
        const requestedAmount = parseFloat(amount) || 0;
        
        if (requestedAmount > availableBalance) {
          setBalanceError(`Insufficient balance! Available: ₹${availableBalance}, Requested: ₹${requestedAmount}`);
          return false; // Don't allow approval
        }
        
        return true; // Allow approval
      } else {
        const errorData = await response.json();
        setBalanceError('Error checking balance: ' + (errorData.message || 'Failed to fetch balance'));
        return false;
      }
    } catch (err) {
      setBalanceError('Error checking balance: ' + (err.message || 'Network error occurred'));
      console.error('Error checking balance:', err);
      return false;
    } finally {
      setIsCheckingBalance(false);
    }
  };

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  // Handle save for amount
  const handleSave = async () => {
    try {
      setIsLoading(true);
      setActionMessage('Saving changes...');
      
      // Check if amount has changed
      if (editedAmount === infra.amount) {
        setActionMessage('No changes to save');
        setTimeout(() => {
          setIsEditMode(false);
        }, 1500);
        return;
      }

      // Use the same API endpoint with PUT method, sending only the changed amount
      const response = await fetch(`${api.BASE_URL}/project/infra/${infra.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('authToken')
        },
        body: JSON.stringify({ amount: editedAmount })
      });
      
      if (response.ok) {
        const data = await response.json();
        setActionMessage('Changes saved successfully!');
        setIsEditMode(false);
        // Refresh the infrastructure list if fetchInfraData function is provided
        if (typeof fetchInfraData === 'function') {
          fetchInfraData();
        }
        // Close modal after a delay
        setTimeout(() => {
          onClose();
        }, 1500);
      } else {
        const errorData = await response.json();
        setActionMessage('Error: ' + (errorData.message || 'Failed to save changes'));
      }
    } catch (err) {
      setActionMessage('Error: ' + (err.message || 'Unknown error occurred'));
      console.error('Error saving changes:', err);
    } finally {
      setIsLoading(false);
    }
  };

const handleProgressSave = async () => {
  try {
    setIsProgressLoading(true);
    setActionMessage('Saving progress data...');
    
    // Check if any progress data has changed
    const hasChanges = Object.keys(progressData).some(key =>
      progressData[key] !== originalProgressData[key]
    );
    
    if (!hasChanges && !uploadedWorkPhoto) {
      setActionMessage('No changes to save');
      setTimeout(() => {
        setIsProgressEditMode(false);
        setActionMessage('');
      }, 1500);
      return;
    }

    // Prepare data based on status
    let dataToSend = {
      status: progressData.status
    };

    // Add specific fields based on status
    switch(progressData.status) {
      case 'not_started':
        dataToSend.remarks = progressData.remarks;
        break;
        
      case 'tendered':
        dataToSend.isFixed = progressData.isFixed;
        if (progressData.isFixed) {
          dataToSend.fixedDate = progressData.fixedDate;
        }
        dataToSend.tenderedRemarks = progressData.tenderedRemarks;
        break;
        
      case 'work_order_issued':
        dataToSend.workOrderIssued = progressData.workOrderIssued;
        if (progressData.workOrderIssued) {
          dataToSend.workOrderDate = progressData.workOrderDate;
        }
        dataToSend.workOrderRemarks = progressData.workOrderRemarks;
        break;
        
      case 'work_in_progress':
        dataToSend.workProgressPercentage = progressData.workProgressPercentage;
        dataToSend.expenditureIncurred = progressData.expenditureIncurred;
        if (progressData.expenditureIncurred) {
          dataToSend.expenditureAmount = progressData.expenditureAmount;
          dataToSend.chequeNumber = progressData.chequeNumber;
          dataToSend.expenditureDate = progressData.expenditureDate;
          dataToSend.expenditureRemarks = progressData.expenditureRemarks;
        }
        // Add uploaded photo path if available
        if (uploadedWorkPhoto) {
          dataToSend.workPhoto = uploadedWorkPhoto;
        }
        break;
        
      case 'physically_completed':
        dataToSend.physicallyCompletedRemarks = progressData.physicallyCompletedRemarks;
        // Add uploaded photo path if available
        if (uploadedWorkPhoto) {
          dataToSend.workPhoto = uploadedWorkPhoto;
        }
        break;
        
      case 'completed_and_bill_paid':
        dataToSend.billDate = progressData.billDate;
        dataToSend.chequeNumber = progressData.chequeNumber;
        dataToSend.physicallyCompletedRemarks = progressData.physicallyCompletedRemarks;
        // Add uploaded photo path if available
        if (uploadedWorkPhoto) {
          dataToSend.workPhoto = uploadedWorkPhoto;
        }
        break;
        
      default:
        setActionMessage('Please select a valid status');
        setIsProgressLoading(false);
        return;
    }

    console.log('Sending progress data:', dataToSend);

    const response = await fetch(`${api.BASE_URL}/project/infra/${infra.id}/stage`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem('authToken')
      },
      body: JSON.stringify(dataToSend)
    });

    if (response.ok) {
      const data = await response.json();
      setActionMessage('Progress data saved successfully!');
      setIsProgressEditMode(false);
      setOriginalProgressData({ ...progressData });
      
      // Clear uploaded file path after successful save
      setUploadedWorkPhoto('');
      
      // Refresh the infrastructure list if fetchInfraData function is provided
      if (typeof fetchInfraData === 'function') {
        fetchInfraData();
      }
      
      // Clear success message after 3 seconds
      setTimeout(() => {
        setActionMessage('');
      }, 3000);
    } else {
      const errorData = await response.json();
      setActionMessage('Error: ' + (errorData.message || 'Failed to save progress data'));
      
      // Clear error message after 5 seconds
      setTimeout(() => {
        setActionMessage('');
      }, 5000);
    }
  } catch (err) {
    setActionMessage('Error: ' + (err.message || 'Unknown error occurred'));
    console.error('Error saving progress data:', err);
    
    // Clear error message after 5 seconds
    setTimeout(() => {
      setActionMessage('');
    }, 5000);
  } finally {
    setIsProgressLoading(false);
  }
};
  // Handle progress data input changes
  const handleProgressInputChange = (field, value) => {
    setProgressData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Cancel progress edit
  const handleProgressCancel = () => {
    setProgressData({ ...originalProgressData });
    setIsProgressEditMode(false);
  };

const handleApprove = async () => {
    // Don't do anything if already approved
    if (infra.status === 'Approved') return;
    
    try {
      setIsLoading(true);
      setActionMessage('Checking balance...');
      
      // Get center code and scheme from infra data
      const centerCode = infra.center; // Using 'center' field for center code
      const scheme = infra.scheme; // Using 'scheme' field from infra data
      const amount = editedAmount || infra.amount;
      
      if (!centerCode) {
        setActionMessage('Error: Center code not found');
        setTimeout(() => setActionMessage(''), 5000);
        return;
      }
      
      if (!scheme) {
        setActionMessage('Error: Scheme not found');
        setTimeout(() => setActionMessage(''), 5000);
        return;
      }
      
      if (!amount) {
        setActionMessage('Error: Infrastructure project amount not found');
        setTimeout(() => setActionMessage(''), 5000);
        return;
      }
      
      // Check balance with both center code and scheme
      const canApprove = await checkBalance(centerCode, scheme, amount);
      
      if (!canApprove) {
        setActionMessage(balanceError || 'Cannot approve due to insufficient balance');
        setTimeout(() => setActionMessage(''), 8000);
        return;
      }
      
      // If balance check passes, proceed with approval
      setActionMessage('Approving infrastructure project...');
      
      // Make API call to approve the infrastructure
      const response = await fetch(`${api.BASE_URL}/project/infra/${infra.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('authToken')
        },
        body: JSON.stringify({ status: 'Approved' })
      });
      
      if (response.ok) {
        await response.json();
        setActionMessage('Infrastructure project approved successfully!');
        window.dispatchEvent(new CustomEvent('refreshNotifications'));

        if (typeof onActionComplete === 'function') {
          await onActionComplete(infra, 'Approved');
        } else {
          if (typeof fetchInfraData === 'function') {
            await fetchInfraData();
          }
          setTimeout(() => onClose(), 1500);
        }
      } else {
        const errorData = await response.json();
        setActionMessage('Error: ' + (errorData.message || 'Failed to approve infrastructure project'));
      }
    } catch (err) {
      setActionMessage('Error: ' + (err.message || 'Unknown error occurred'));
      console.error('Error approving infrastructure project:', err);
    } finally {
      setIsLoading(false);
    }
  };
  // Handle reject action
const handleReject = async () => {
  if (!rejectionReason.trim()) {
    setActionMessage('Please provide a reason for rejection');
    setTimeout(() => setActionMessage(''), 3000);
    return;
  }
  
  try {
    setIsLoading(true);
    setActionMessage('Rejecting infrastructure project...');
    
    const response = await fetch(`${api.BASE_URL}/project/infra/${infra.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem('authToken')
      },
      body: JSON.stringify({ 
        status: 'Rejected',
        rejectionReason: rejectionReason.trim()
      })
    });
    
    if (response.ok) {
      setActionMessage('Infrastructure project rejected successfully!');
      setShowRejectionReason(false);
      setRejectionReason('');
      if (typeof onActionComplete === 'function') {
        await onActionComplete(infra, 'Rejected');
      } else {
        if (typeof fetchInfraData === 'function') {
          await fetchInfraData();
        }
        setTimeout(() => onClose(), 1500);
      }
    } else {
      const errorData = await response.json();
      setActionMessage('Error: ' + (errorData.message || 'Failed to reject infrastructure project'));
    }
  } catch (err) {
    setActionMessage('Error: ' + (err.message || 'Unknown error occurred'));
    console.error('Error rejecting infrastructure project:', err);
  } finally {
    setIsLoading(false);
  }
};
  // Handle delete action
  const handleDelete = async () => {
    // Confirm deletion
    if (!window.confirm('Are you sure you want to delete this infrastructure project? This action cannot be undone.')) {
      return;
    }
    
    try {
      setIsLoading(true);
      setActionMessage('Deleting infrastructure project...');
      
      // Send DELETE status to the API
      const response = await fetch(`${api.BASE_URL}/project/infra/${infra.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('authToken')
        },
        body: JSON.stringify({ status: 'Deleted' })
      });
      
      if (response.ok) {
        const data = await response.json();
        setActionMessage('Infrastructure project deleted successfully!');
        // Refresh the infrastructure list if fetchInfraData function is provided
        if (typeof fetchInfraData === 'function') {
          fetchInfraData();
        }
        // Close modal after a delay
        setTimeout(() => {
          onClose();
        }, 1500);
      } else {
        const errorData = await response.json();
        setActionMessage('Error: ' + (errorData.message || 'Failed to delete infrastructure project'));
      }
    } catch (err) {
      setActionMessage('Error: ' + (err.message || 'Unknown error occurred'));
      console.error('Error deleting infrastructure project:', err);
    } finally {
      setIsLoading(false);
      // Close modal after a delay
      setTimeout(() => {
        onClose();
      }, 2000);
    }
  };

  // Determine approve button state
  const isApproved = infra.status === 'Approved';
  const isRejected = infra.status === 'Rejected';
  const isDeleted = infra.status === 'Deleted';

  // Check if user can see progress tracking section
// Check if user can see progress tracking section - Only for non-department users when approved
 //const canSeeProgressTracking = isApproved && userRole !== 'department';
 // Infrastructure work-status updates are disabled.
  const canSeeProgressTracking = false;
  // Create status badge color based on status
  const getStatusColor = (status) => {
    switch(status) {
      case 'Approved': return 'bg-green-100 text-green-800 border-green-200';
      case 'Rejected': return 'bg-red-100 text-red-800 border-red-200';
      case 'In Progress': return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'Completed': return 'bg-purple-100 text-purple-800 border-purple-200';
      case 'Deleted': return 'bg-gray-100 text-gray-800 border-gray-200';
      default: return 'bg-yellow-100 text-yellow-800 border-yellow-200';
    }
  };

  // Create action message style based on message content
  const getActionMessageStyle = (message) => {
    if (message.includes('Error')) {
      return 'bg-red-50 text-red-700 border border-red-100';
    } else if (message.includes('Approving') || message.includes('Rejecting') || message.includes('Saving') || message.includes('Deleting')) {
      return 'bg-blue-50 text-blue-700 border border-blue-100';
    } else {
      return 'bg-green-50 text-green-700 border border-green-100';
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
        {/* Modal header - with premium styling */}
        <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center bg-gradient-to-r from-indigo-50 to-purple-50">
          <div className="flex items-center">
            <h3 className="text-lg font-semibold text-gray-900">Infrastructure Details</h3>
            <div className={`ml-3 px-3 py-1 rounded-full text-xs font-medium border ${getStatusColor(infra.status || 'Pending')}`}>
              {infra.status || 'Pending'}
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500 focus:outline-none transition-colors p-1 rounded-full hover:bg-gray-100"
            disabled={isLoading}
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Action message - with enhanced styling */}
        {actionMessage && (
          <div className={`px-6 py-3 ${getActionMessageStyle(actionMessage)} rounded-md mx-6 my-3 text-center text-sm font-medium`}>
            {actionMessage}
          </div>
        )}
 {/* Rejection Reason Section for department users */}
        {userRole === 'department' && showRejectionReason && (
          <div className="mx-6 my-3">
            <div className="bg-red-50 rounded-lg border border-red-200 shadow-sm overflow-hidden">
              <div className="px-4 py-3 bg-red-100 border-b border-red-200">
                <h4 className="font-medium text-red-800">Reason for Rejection</h4>
              </div>
              <div className="p-4">
                <label className="block text-sm font-medium text-red-700 mb-2">
                  Please provide a reason for rejecting this infrastructure project:
                </label>
                <textarea
                  value={rejectionReason}
                  onChange={(e) => setRejectionReason(e.target.value)}
                  className="w-full rounded-md border-red-300 shadow-sm focus:border-red-500 focus:ring-red-500 sm:text-sm"
                  rows="3"
                  placeholder="Enter reason for rejection..."
                  required
                />
                <div className="mt-3 flex gap-3">
                  <button
                    onClick={handleReject}
                    className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700"
                    disabled={!rejectionReason.trim() || isLoading}
                  >
                    {isLoading ? 'Rejecting...' : 'Confirm Rejection'}
                  </button>
                  <button
                    onClick={() => {
                      setShowRejectionReason(false);
                      setRejectionReason('');
                    }}
                    className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* Modal body - with improved spacing and card-like sections */}
        <div className="flex-1 overflow-y-auto px-6 py-4">
          <div className="space-y-6">
            {/* Infrastructure code - with better styling */}
            <div className="bg-gray-50 rounded-lg p-4 font-mono text-sm break-all border border-gray-200 shadow-sm">
              <div className="text-xs text-gray-500 mb-1 font-sans">Infrastructure Code</div>
              {generateInfraCode(infra)}
            </div>
            
            {/* Infrastructure details - with card styling */}
            <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
              <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
                <h4 className="font-medium text-gray-700">Project Information</h4>
              </div>
              <div className="p-4">
<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
  <div>
    <h4 className="text-sm font-medium text-gray-500">Title</h4>
    <p className="mt-1 text-gray-900">{safeRender(infra.title)}</p>
  </div>
  <div>
    <h4 className="text-sm font-medium text-gray-500">Type</h4>
    <p className="mt-1 text-gray-900">{safeRender(infra.training_type)}</p>
  </div>
  <div>
    <h4 className="text-sm font-medium text-gray-500">Center</h4>
    <p className="mt-1 text-gray-900">{safeRender(infra.center_name)}</p>
  </div>
  <div>
    <h4 className="text-sm font-medium text-gray-500">Scheme</h4>
    <p className="mt-1 text-gray-900">{safeRender(infra.scheme_name)}</p>
  </div>
  <div>
    <h4 className="text-sm font-medium text-gray-500">A.S Date</h4>
    <p className="mt-1 text-gray-900">{formatDate(infra.asDate)}</p>
  </div>
  <div>
    <h4 className="text-sm font-medium text-gray-500">A.S Number</h4>
    <p className="mt-1 text-gray-900">{safeRender(infra.asNumber)}</p>
  </div>
  
  {/* A.S File - Only visible for department users */}
  {userRole === 'department' && (
    <div>
      <h4 className="text-sm font-medium text-gray-500">A.S File</h4>
      {infra.asFile && infra.asFile.trim() !== '' ? (
        <a 
          href={`https://crd-training.in/uploads/${infra.asFile}`} 
          target="_blank" 
          rel="noopener noreferrer"
          className="mt-1 text-blue-600 hover:text-blue-800 underline flex items-center"
        >
          <svg className="h-4 w-4 mr-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
           A.S File
        </a>
      ) : (
        <p className="mt-1 text-gray-900">No file uploaded</p>
      )}
    </div>
  )}
  
  <div>
    <h4 className="text-sm font-medium text-gray-500">Amount</h4>
    {isEditMode ? (
      <input
        type="number"
        value={editedAmount}
        onChange={(e) => setEditedAmount(e.target.value)}
        className="mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
        placeholder="Enter amount"
      />
    ) : (
      <p className="mt-1 text-gray-900">{formatCurrency(infra.amount)}</p>
    )}
  </div>
  <div>
    <h4 className="text-sm font-medium text-gray-500">Units</h4>
    <p className="mt-1 text-gray-900">{safeRender(infra.units)}</p>
  </div>
</div>
              </div>
            </div>

            {/* Treasury Bill Document */}
<div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
  <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
    <h4 className="font-medium text-gray-700">Treasury Bill Document</h4>
  </div>

  <div className="p-4">
    {getTreasuryDocumentPath() ? (
      <a
        href={getUploadUrl(getTreasuryDocumentPath())}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-600 hover:text-blue-800 underline text-sm"
      >
        View Treasury Bill Document
      </a>
    ) : (
      <p className="text-sm text-gray-500 mb-3">No document uploaded</p>
    )}

    {userRole !== 'department' && isApproved && !isDeleted && !getTreasuryDocumentPath() && (
      <div className="mt-3">
        <label className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 cursor-pointer">
          {treasuryUploading ? 'Uploading...' : 'Upload Treasury Bill Document'}
          <input
            type="file"
            accept="application/pdf,.pdf"
            onChange={handleTreasuryBillUpload}
            disabled={treasuryUploading || isLoading}
            className="hidden"
          />
        </label>
      </div>
    )}
  </div>
</div>

{/* Financial Summary */}
<div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
  <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
    <h4 className="font-medium text-gray-700">Financial Summary</h4>
  </div>

  <div className="p-4">
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div className="bg-blue-50 rounded-lg p-4 border border-blue-100">
        <h4 className="text-sm font-medium text-blue-700">Amount Allocated</h4>
        <p className="mt-1 text-blue-900 font-semibold">
          {formatCurrency(infra.amount)}
        </p>
      </div>

      <div className="bg-orange-50 rounded-lg p-4 border border-orange-100">
        <h4 className="text-sm font-medium text-orange-700">Expenditure Incurred</h4>

        <input
          type="number"
          min="0"
          value={editedAmountSpent}
          onChange={(event) => setEditedAmountSpent(event.target.value)}
          className="mt-2 w-full rounded-md border-orange-200 shadow-sm focus:border-orange-500 focus:ring-orange-500 sm:text-sm"
          placeholder="Enter Expenditure Incurred"
          disabled={userRole === 'department' || !isApproved || isDeleted || isLoading}
        />

        <p className="mt-2 text-orange-900 font-semibold">
          {formatCurrency(getInfraExpenditureIncurred())}
        </p>

        {userRole !== 'department' && isApproved && !isDeleted && (
          <button
            type="button"
            onClick={handleSaveAmountSpent}
            className="mt-3 px-3 py-1.5 text-xs font-medium text-white bg-orange-600 rounded hover:bg-orange-700"
            disabled={isLoading}
          >
            {isLoading ? 'Saving...' : 'Save Expenditure'}
          </button>
        )}
      </div>

      <div className="bg-green-50 rounded-lg p-4 border border-green-100">
        <h4 className="text-sm font-medium text-green-700">Balance Amount</h4>
        <p className="mt-1 text-green-900 font-semibold">
          {formatCurrency(getBalanceAmount())}
        </p>
      </div>
    </div>
  </div>
</div>

            {/* Description if available */}
            {infra.description && (
              <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
                <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
                  <h4 className="font-medium text-gray-700">Description</h4>
                </div>
                <div className="p-4">
                  <p className="text-gray-700 whitespace-pre-wrap">{safeRender(infra.description)}</p>
                </div>
              </div>
            )}

            {/* Project dates if available */}
            {(infra.startDate || infra.endDate || infra.approvedDate) && (
              <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
                <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
                  <h4 className="font-medium text-gray-700">Project Timeline</h4>
                </div>
                <div className="p-4">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {infra.startDate && (
                      <div>
                        <h4 className="text-sm font-medium text-gray-500">Start Date</h4>
                        <p className="mt-1 text-gray-900">{formatDate(infra.startDate)}</p>
                      </div>
                    )}
                    
                    {infra.endDate && (
                      <div>
                        <h4 className="text-sm font-medium text-gray-500">End Date</h4>
                        <p className="mt-1 text-gray-900">{formatDate(infra.endDate)}</p>
                      </div>
                    )}
                    
                    {infra.approvedDate && (
                      <div>
                        <h4 className="text-sm font-medium text-gray-500">Approval Date</h4>
                        <p className="mt-1 text-gray-900">{formatDate(infra.approvedDate)}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* Contractor information if available */}
            {infra.contractor && (
              <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
                <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
                  <h4 className="font-medium text-gray-700">Contractor Details</h4>
                </div>
                <div className="p-4">
                  <p className="text-gray-700">{safeRender(infra.contractor)}</p>
                </div>
              </div>
            )}

            {/* Additional Details - Direct method instead of dynamic filtering */}
            <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
              <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
                <h4 className="font-medium text-gray-700">Additional Details</h4>
              </div>
              <div className="p-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Manually define fields we want to show here */}
                  {infra.institute && (
                    <div>
                      <h4 className="text-sm font-medium text-gray-500">Institute</h4>
                      <p className="mt-1 text-gray-900">{safeRender(infra.institute)}</p>
                    </div>
                  )}
                  
                  {infra.year && (
                    <div>
                      <h4 className="text-sm font-medium text-gray-500">Year</h4>
                      <p className="mt-1 text-gray-900">{safeRender(infra.year)}</p>
                    </div>
                  )}
                  
                  {infra.month && (
                    <div>
                      <h4 className="text-sm font-medium text-gray-500">Month</h4>
                      <p className="mt-1 text-gray-900">{safeRender(infra.month)}</p>
                    </div>
                  )}
                  
                  {infra.stitle && (
                    <div>
                      <h4 className="text-sm font-medium text-gray-500">Short Title</h4>
                      <p className="mt-1 text-gray-900">{safeRender(infra.stitle)}</p>
                    </div>
                  )}
                  
                  {infra.sno && (
                    <div>
                      <h4 className="text-sm font-medium text-gray-500">Serial Number</h4>
                      <p className="mt-1 text-gray-900">{safeRender(infra.sno)}</p>
                    </div>
                  )}
                  
                  {infra.district && (
                    <div>
                      <h4 className="text-sm font-medium text-gray-500">District</h4>
                      <p className="mt-1 text-gray-900">{safeRender(infra.district)}</p>
                    </div>
                  )}
                  
                  {infra.state && (
                    <div>
                      <h4 className="text-sm font-medium text-gray-500">State</h4>
                      <p className="mt-1 text-gray-900">{safeRender(infra.state)}</p>
                    </div>
                  )}
                  
                  {infra.duration && (
                    <div>
                      <h4 className="text-sm font-medium text-gray-500">Duration</h4>
                      <p className="mt-1 text-gray-900">{safeRender(infra.duration)}</p>
                    </div>
                  )}
                  
                  {infra.category && (
                    <div>
                      <h4 className="text-sm font-medium text-gray-500">Category</h4>
                      <p className="mt-1 text-gray-900">{safeRender(infra.category)}</p>
                    </div>
                  )}
                  
                  {/* Add more fields as needed */}
                </div>
              </div>
            </div>
{/* Previous Stage Records - Show if StageData exists */}
{infra.StageData && infra.StageData.length > 0 && (
  <div className="bg-white rounded-lg border border-green-200 shadow-sm overflow-hidden">
    <div className="px-4 py-3 bg-green-50 border-b border-green-200">
      <h4 className="font-medium text-green-800">Work Progress History</h4>
    </div>
    <div className="p-4">
      <div className="space-y-4">
        {infra.StageData.filter(stage => stage && Object.keys(stage).length > 0).map((stage, index) => (
          <div key={index} className="p-4 bg-gray-50 rounded-lg border border-gray-200">
            <div className="flex items-center justify-between mb-3">
              <h5 className="text-sm font-semibold text-gray-800 capitalize">
                {stage.status ? stage.status.replace(/_/g, ' ') : `Entry ${index + 1}`}
              </h5>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Handle NEW FORMAT (with status field) */}
              {stage.status && (
                <>
                  {stage.status === 'not_started' && stage.remarks && (
                    <div className="md:col-span-2">
                      <h6 className="text-sm font-medium text-gray-700">Remarks</h6>
                      <p className="mt-1 text-gray-900">{stage.remarks}</p>
                    </div>
                  )}
                  
                  {stage.status === 'tendered' && (
                    <>
                      {stage.isFixed !== undefined && (
                        <div>
                          <h6 className="text-sm font-medium text-gray-700">Fixed Status</h6>
                          <p className="mt-1 text-gray-900">{stage.isFixed ? 'Yes' : 'No'}</p>
                        </div>
                      )}
                      {stage.fixedDate && (
                        <div>
                          <h6 className="text-sm font-medium text-gray-700">Fixed Date</h6>
                          <p className="mt-1 text-gray-900">{formatDate(stage.fixedDate)}</p>
                        </div>
                      )}
                      {stage.tenderedRemarks && (
                        <div className="md:col-span-2">
                          <h6 className="text-sm font-medium text-gray-700">Remarks</h6>
                          <p className="mt-1 text-gray-900">{stage.tenderedRemarks}</p>
                        </div>
                      )}
                    </>
                  )}
                  
                  {stage.status === 'work_order_issued' && (
                    <>
                      {stage.workOrderIssued !== undefined && (
                        <div>
                          <h6 className="text-sm font-medium text-gray-700">Work Order Status</h6>
                          <p className="mt-1 text-gray-900">{stage.workOrderIssued ? 'Issued' : 'Not Issued'}</p>
                        </div>
                      )}
                      {stage.workOrderDate && (
                        <div>
                          <h6 className="text-sm font-medium text-gray-700">Work Order Date</h6>
                          <p className="mt-1 text-gray-900">{formatDate(stage.workOrderDate)}</p>
                        </div>
                      )}
                      {stage.workOrderRemarks && (
                        <div className="md:col-span-2">
                          <h6 className="text-sm font-medium text-gray-700">Remarks</h6>
                          <p className="mt-1 text-gray-900">{stage.workOrderRemarks}</p>
                        </div>
                      )}
                    </>
                  )}
                  
                  {stage.status === 'work_in_progress' && (
                    <>
                      {stage.workProgressPercentage && (
                        <div>
                          <h6 className="text-sm font-medium text-gray-700">Progress</h6>
                          <p className="mt-1 text-gray-900">{stage.workProgressPercentage}%</p>
                        </div>
                      )}
                      {stage.expenditureIncurred !== undefined && (
                        <div>
                          <h6 className="text-sm font-medium text-gray-700">Expenditure Status</h6>
                          <p className="mt-1 text-gray-900">{stage.expenditureIncurred ? 'Incurred' : 'Not Incurred'}</p>
                        </div>
                      )}
                      {stage.expenditureAmount && (
                        <div>
                          <h6 className="text-sm font-medium text-gray-700">Expenditure Amount</h6>
                          <p className="mt-1 text-gray-900">₹{parseInt(stage.expenditureAmount).toLocaleString()}</p>
                        </div>
                      )}
                      {stage.chequeNumber && (
                        <div>
                          <h6 className="text-sm font-medium text-gray-700">Cheque Number</h6>
                          <p className="mt-1 text-gray-900">{stage.chequeNumber}</p>
                        </div>
                      )}
                      {stage.expenditureDate && (
                        <div>
                          <h6 className="text-sm font-medium text-gray-700">Expenditure Date</h6>
                          <p className="mt-1 text-gray-900">{formatDate(stage.expenditureDate)}</p>
                        </div>
                      )}
                      {stage.expenditureRemarks && (
                        <div className="md:col-span-2">
                          <h6 className="text-sm font-medium text-gray-700">Expenditure Remarks</h6>
                          <p className="mt-1 text-gray-900">{stage.expenditureRemarks}</p>
                        </div>
                      )}
                      {stage.workPhoto && (
                        <div className="md:col-span-2">
                          <h6 className="text-sm font-medium text-gray-700">Work Photo</h6>
                          <img 
                            src={`https://crd-training.in/uploads/${stage.workPhoto}`} 
                            alt="Work Progress" 
                            className="mt-1 w-32 h-32 object-cover rounded border border-gray-300"
                          />
                        </div>
                      )}
                    </>
                  )}
                  
                  {stage.status === 'physically_completed' && stage.physicallyCompletedRemarks && (
                    <div className="md:col-span-2">
                      <h6 className="text-sm font-medium text-gray-700">Completion Remarks</h6>
                      <p className="mt-1 text-gray-900">{stage.physicallyCompletedRemarks}</p>
                    </div>
                  )}
                  
                  {stage.status === 'completed_and_bill_paid' && (
                    <>
                      {stage.billDate && (
                        <div>
                          <h6 className="text-sm font-medium text-gray-700">Bill Date</h6>
                          <p className="mt-1 text-gray-900">{formatDate(stage.billDate)}</p>
                        </div>
                      )}
                      {stage.chequeNumber && (
                        <div>
                          <h6 className="text-sm font-medium text-gray-700">Cheque Number</h6>
                          <p className="mt-1 text-gray-900">{stage.chequeNumber}</p>
                        </div>
                      )}
                      {stage.physicallyCompletedRemarks && (
                        <div className="md:col-span-2">
                          <h6 className="text-sm font-medium text-gray-700">Final Remarks</h6>
                          <p className="mt-1 text-gray-900">{stage.physicallyCompletedRemarks}</p>
                        </div>
                      )}
                      {stage.workPhoto && (
                        <div className="md:col-span-2">
                          <h6 className="text-sm font-medium text-gray-700">Work Photo</h6>
                          <img 
                            src={`https://crd-training.in/uploads/${stage.workPhoto}`} 
                            alt="Final Work" 
                            className="mt-1 w-32 h-32 object-cover rounded border border-gray-300"
                          />
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
              
              {/* Handle OLD FORMAT (without status field) */}
              {!stage.status && (
                <>
                  {stage.stageOfWorkDuringLastReview && (
                    <div>
                      <h6 className="text-sm font-medium text-gray-700">Stage During Last Review</h6>
                      <p className="mt-1 text-gray-900">{stage.stageOfWorkDuringLastReview}</p>
                    </div>
                  )}
                  {stage.stageOfWorkAsOnDate && (
                    <div>
                      <h6 className="text-sm font-medium text-gray-700">Stage As On Date</h6>
                      <p className="mt-1 text-gray-900">{formatDate(stage.stageOfWorkAsOnDate)}</p>
                    </div>
                  )}
                  {stage.expenditureIncurredSoFar && (
                    <div>
                      <h6 className="text-sm font-medium text-gray-700">Expenditure Incurred</h6>
                      <p className="mt-1 text-gray-900">₹{parseInt(stage.expenditureIncurredSoFar).toLocaleString()}</p>
                    </div>
                  )}
                  {stage.chequeNumber && (
                    <div>
                      <h6 className="text-sm font-medium text-gray-700">Cheque Number</h6>
                      <p className="mt-1 text-gray-900">{stage.chequeNumber}</p>
                    </div>
                  )}
                  {stage.remarks && (
                    <div className="md:col-span-2">
                      <h6 className="text-sm font-medium text-gray-700">Remarks</h6>
                      <p className="mt-1 text-gray-900">{stage.remarks}</p>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
)}
{/* Progress Tracking Section - Only for state/region users, approved status, and SFC scheme */}
{canSeeProgressTracking && (
  <div className="bg-white rounded-lg border border-indigo-200 shadow-sm overflow-hidden">
    <div className="px-4 py-3 bg-indigo-50 border-b border-indigo-200">
      <h4 className="font-medium text-indigo-800">Status of Work</h4>
    </div>
    <div className="p-4">
      <div className="space-y-4">
        
        {/* Work Status Dropdown - Proper width */}
        <div className="max-w-xs">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Work Status *
          </label>
          <select
            value={progressData.status}
            onChange={(e) => handleProgressInputChange('status', e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 bg-white"
            required
          >
            <option value="">Select Status</option>
            <option value="not_started">Not Started</option>
            <option value="tendered">Tendered</option>
            <option value="work_order_issued">Work Order Issued</option>
            <option value="work_in_progress">Work in Progress</option>
            <option value="physically_completed">Physically Completed</option>
            <option value="completed_and_bill_paid">Completed and Bill Paid</option>
          </select>
        </div>

        {/* Not Started - Only Remarks */}
        {progressData.status === 'not_started' && (
          <div className="max-w-md">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Remarks *
            </label>
            <textarea
              value={progressData.remarks}
              onChange={(e) => handleProgressInputChange('remarks', e.target.value)}
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 resize-vertical"
              rows="3"
              placeholder="Enter remarks..."
              required
            />
          </div>
        )}

        {/* Tendered Status */}
        {progressData.status === 'tendered' && (
          <div className="space-y-3">
            <div className="flex items-center">
              <input
                type="checkbox"
                id="isFixed"
                checked={progressData.isFixed}
                onChange={(e) => handleProgressInputChange('isFixed', e.target.checked)}
                className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
              />
              <label htmlFor="isFixed" className="ml-2 block text-sm text-gray-700">
                Fixed
              </label>
            </div>
            
            {progressData.isFixed && (
              <div className="max-w-xs">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Fixed Date *
                </label>
                <input
                  type="date"
                  value={progressData.fixedDate}
                  onChange={(e) => handleProgressInputChange('fixedDate', e.target.value)}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                  required
                />
              </div>
            )}
            
            <div className="max-w-md">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Remarks *
              </label>
              <textarea
                value={progressData.tenderedRemarks}
                onChange={(e) => handleProgressInputChange('tenderedRemarks', e.target.value)}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 resize-vertical"
                rows="3"
                placeholder="Enter remarks..."
                required
              />
            </div>
          </div>
        )}

        {/* Work Order Issued Status */}
        {progressData.status === 'work_order_issued' && (
          <div className="space-y-3">
            <div className="flex items-center">
              <input
                type="checkbox"
                id="workOrderIssued"
                checked={progressData.workOrderIssued}
                onChange={(e) => handleProgressInputChange('workOrderIssued', e.target.checked)}
                className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
              />
              <label htmlFor="workOrderIssued" className="ml-2 block text-sm text-gray-700">
                Work Order Issued
              </label>
            </div>
            
            {progressData.workOrderIssued && (
              <div className="max-w-xs">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Work Order Date *
                </label>
                <input
                  type="date"
                  value={progressData.workOrderDate}
                  onChange={(e) => handleProgressInputChange('workOrderDate', e.target.value)}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                  required
                />
              </div>
            )}
            
            <div className="max-w-md">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Remarks *
              </label>
              <textarea
                value={progressData.workOrderRemarks}
                onChange={(e) => handleProgressInputChange('workOrderRemarks', e.target.value)}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 resize-vertical"
                rows="3"
                placeholder="Enter remarks..."
                required
              />
            </div>
          </div>
        )}

        {/* Work in Progress Status */}
        {progressData.status === 'work_in_progress' && (
          <div className="space-y-4">
            {/* Progress Percentage Slider - Proper width */}
            <div className="max-w-sm">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Progress: {progressData.workProgressPercentage}%
              </label>
              <div className="relative">
                <input
                  type="range"
                  min="25"
                  max="98"
                  step="1"
                  value={progressData.workProgressPercentage}
                  onChange={(e) => handleProgressInputChange('workProgressPercentage', parseInt(e.target.value))}
                  className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
                  style={{
                    background: `linear-gradient(to right, #4F46E5 0%, #4F46E5 ${((progressData.workProgressPercentage - 25) / (98 - 25)) * 100}%, #E5E7EB ${((progressData.workProgressPercentage - 25) / (98 - 25)) * 100}%, #E5E7EB 100%)`
                  }}
                />
                <div className="flex justify-between text-xs text-gray-400 mt-1">
                  <span>25%</span>
                  <span>50%</span>
                  <span>75%</span>
                  <span>98%</span>
                </div>
              </div>
            </div>

            {/* Work Photo Upload - Proper width */}
            <div className="max-w-sm">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Work Photo *
              </label>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleFileUpload('workPhoto', e.target.files[0])}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 file:mr-3 file:py-1 file:px-3 file:rounded file:border-0 file:text-sm file:font-medium file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
                required
              />
              {progressData.workPhoto && (
                <div className="mt-3">
                  <img
                    src={URL.createObjectURL(progressData.workPhoto)}
                    alt="Preview"
                    className="w-24 h-24 object-cover rounded border border-gray-300"
                  />
                  <p className="text-xs text-green-600 mt-1">{progressData.workPhoto.name}</p>
                </div>
              )}
            </div>

            {/* Expenditure Section - Proper width */}
            <div className="space-y-3">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="expenditureIncurred"
                  checked={progressData.expenditureIncurred}
                  onChange={(e) => handleProgressInputChange('expenditureIncurred', e.target.checked)}
                  className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                />
                <label htmlFor="expenditureIncurred" className="ml-2 block text-sm text-gray-700">
                  Expenditure Incurred
                </label>
              </div>
              
              {progressData.expenditureIncurred && (
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Amount *
                    </label>
                    <input
                      type="number"
                      value={progressData.expenditureAmount}
                      onChange={(e) => handleProgressInputChange('expenditureAmount', e.target.value)}
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                      placeholder="Amount"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Cheque Number *
                    </label>
                    <input
                      type="text"
                      value={progressData.chequeNumber}
                      onChange={(e) => handleProgressInputChange('chequeNumber', e.target.value)}
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                      placeholder="Cheque No."
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Date *
                    </label>
                    <input
                      type="date"
                      value={progressData.expenditureDate}
                      onChange={(e) => handleProgressInputChange('expenditureDate', e.target.value)}
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Remarks *
                    </label>
                    <textarea
                      value={progressData.expenditureRemarks}
                      onChange={(e) => handleProgressInputChange('expenditureRemarks', e.target.value)}
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 resize-vertical"
                      rows="2"
                      placeholder="Remarks"
                      required
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Physically Completed Status - Only Remarks */}
        {progressData.status === 'physically_completed' && (
          <div className="max-w-md">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Remarks *
            </label>
            <textarea
              value={progressData.physicallyCompletedRemarks}
              onChange={(e) => handleProgressInputChange('physicallyCompletedRemarks', e.target.value)}
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 resize-vertical"
              rows="3"
              placeholder="Enter remarks..."
              required
            />
          </div>
        )}

        {/* Completed and Bill Paid Status - Bill Date, Cheque Number, Work Photo, Remarks */}
        {progressData.status === 'completed_and_bill_paid' && (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Bill Date *
                </label>
                <input
                  type="date"
                  value={progressData.billDate}
                  onChange={(e) => handleProgressInputChange('billDate', e.target.value)}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Cheque Number *
                </label>
                <input
                  type="text"
                  value={progressData.chequeNumber}
                  onChange={(e) => handleProgressInputChange('chequeNumber', e.target.value)}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                  placeholder="Cheque No."
                  required
                />
              </div>
            </div>
            
            <div className="max-w-sm">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Work Photo *
              </label>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleFileUpload('workPhoto', e.target.files[0])}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 file:mr-3 file:py-1 file:px-3 file:rounded file:border-0 file:text-sm file:font-medium file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
                required
              />
              {progressData.workPhoto && (
                <div className="mt-3">
                  <img
                    src={URL.createObjectURL(progressData.workPhoto)}
                    alt="Preview"
                    className="w-24 h-24 object-cover rounded border border-gray-300"
                  />
                  <p className="text-xs text-green-600 mt-1">{progressData.workPhoto.name}</p>
                </div>
              )}
            </div>
            
            <div className="max-w-md">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Remarks *
              </label>
              <textarea
                value={progressData.physicallyCompletedRemarks}
                onChange={(e) => handleProgressInputChange('physicallyCompletedRemarks', e.target.value)}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 resize-vertical"
                rows="3"
                placeholder="Enter remarks..."
                required
              />
            </div>
          </div>
        )}

        {/* Save Button */}
        <div className="flex justify-end pt-4 border-t border-gray-200">
          <button
            onClick={handleProgressSave}
            className="px-6 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gradient-to-r from-indigo-600 to-purple-500 hover:from-indigo-700 hover:to-purple-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all"
            disabled={isProgressLoading || !progressData.status}
          >
            {isProgressLoading ? (
              <span className="flex items-center">
                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Saving...
              </span>
            ) : 'Save Progress'}
          </button>
        </div>
      </div>
    </div>
  </div>
)}
            {/* Balance Information - shown when checking balance */}
            {balanceData && (
              <div className="bg-blue-50 rounded-lg border border-blue-200 shadow-sm overflow-hidden">
                <div className="px-4 py-3 bg-blue-100 border-b border-blue-200">
                  <h4 className="font-medium text-blue-800">Balance Information</h4>
                </div>
                <div className="p-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <h4 className="text-sm font-medium text-blue-600">Available Balance</h4>
                      <p className="mt-1 text-blue-900 font-semibold">₹{balanceData.data && balanceData.data[0] ? balanceData.data[0].balance : 0}</p>
                    </div>
                    <div>
                      <h4 className="text-sm font-medium text-blue-600">Requested Amount</h4>
                      <p className="mt-1 text-blue-900 font-semibold">₹{editedAmount || infra.amount}</p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Modal footer with action buttons - with premium styling */}
        <div className="px-6 py-4 border-t border-gray-200 bg-gray-50 flex flex-wrap justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 shadow-sm transition-colors"
            disabled={isLoading}
          >
            Close
          </button>
          
          {/* Edit and Save buttons for department users */}
       {userRole === 'department' && !isDeleted && !isApproved && (
            <>
              {!isEditMode ? (
                <button
                  onClick={() => setIsEditMode(true)}
                  className="px-4 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                  disabled={isLoading}
                >
                  Edit
                </button>
              ) : (
                <>
                  <button
                    onClick={() => {
                      setIsEditMode(false);
                      setEditedAmount(infra.amount || '');
                    }}
                    className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 shadow-sm transition-colors"
                    disabled={isLoading}
                  >
                    Cancel Edit
                  </button>
                  <button
                    onClick={handleSave}
                    className="px-4 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-700 hover:to-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <span className="flex items-center">
                        <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Saving...
                      </span>
                    ) : 'Save'}
                  </button>
                </>
              )}
            </>
          )}
          
          {/* Delete button - visible for department users when not in edit mode and not already deleted */}
       {/* Delete button - visible for department users when not in edit mode, not already deleted, and not approved */}
{userRole === 'department' && !isEditMode && !isDeleted && isApproved && (
            <button
              onClick={handleDelete}
              className="px-4 py-2 border border-red-300 rounded-lg text-sm font-medium text-red-700 bg-white hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 shadow-sm transition-colors"
              disabled={isLoading}
            >
              {isLoading ? (
                <span className="flex items-center">
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-red-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Deleting...
                </span>
              ) : 'Delete'}
            </button>
          )}
          
          {/* Approve/Reject buttons only visible when not in edit mode and not deleted */}
          {userRole === 'department' && !isApproved && !isRejected && !isDeleted && !isEditMode && (
            <>
      <button
  onClick={() => setShowRejectionReason(true)}
  className="px-4 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors"
  disabled={isLoading}
>
  Reject
</button>
              <button
                onClick={handleApprove}
                className="px-4 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-gradient-to-r from-indigo-600 to-purple-500 hover:from-indigo-700 hover:to-purple-600 focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all"
                disabled={isLoading || isCheckingBalance}
              >
                {isLoading || isCheckingBalance ? (
                  <span className="flex items-center">
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    {isCheckingBalance ? 'Checking Balance...' : 'Processing...'}
                  </span>
                ) : 'Approve'}
              </button>
            </>
          )}
          
          {/* Show status message for rejected projects */}
          {userRole === 'department' && isRejected && (
            <span className="text-sm font-medium text-red-600">
              {/* Empty span */}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default InfraDetailsModal;